module.exports = __webpack_public_path__ + "img/oocl.25fceefd.jpg";